var _mask, _g, _path, _mask2, _g2, _mask3, _g3, _mask4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresssuitTop = function SvgPresssuitTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit-top_svg__a",
    width: 32,
    height: 24,
    x: 2,
    y: 6,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 7h32v22.176H2z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit-top_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M29.125 20.87 34 19.154v-4.63A7.525 7.525 0 0 0 26.476 7H9.525A7.525 7.525 0 0 0 2 14.525v4.63l4.875 1.714.849 8.307H28.26z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m29.117 20.87-.857 8.306zM29.112 20.914h.005c.439-4.424-2.65-3.58-2.65-13.914h-1.77s-1.454 3.954-2.707 6.012c-1.25 2.054-3.99 4.306-3.997 7.845l-.001.012c0-3.547-2.747-5.8-4-7.857C12.743 10.954 11.287 7 11.287 7h-1.77c0 10.334-3.088 9.49-2.65 13.914v-.045l.858 8.307H28.26z",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit-top_svg__b",
    width: 24,
    height: 24,
    x: 6,
    y: 6,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.697 7s-1.454 3.954-2.707 6.012c-1.25 2.054-3.99 4.306-3.998 7.845v.011c0-3.546-2.747-5.8-3.999-7.856C12.741 10.954 11.287 7 11.287 7h-1.77c0 10.334-3.09 9.49-2.65 13.914v-.045l.857 8.307H28.26l.852-8.262h.005c.44-4.425-2.65-3.58-2.65-13.914",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit-top_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E64909",
    strokeWidth: 2,
    d: "m9.443 41.087 2.721-11.912-.469-4.549"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit-top_svg__c",
    width: 24,
    height: 24,
    x: 6,
    y: 6,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.697 7s-1.454 3.954-2.707 6.012c-1.25 2.054-3.99 4.306-3.998 7.845v.011c0-3.546-2.747-5.8-3.999-7.856C12.741 10.954 11.287 7 11.287 7h-1.77c0 10.334-3.09 9.49-2.65 13.914v-.045l.857 8.307H28.26l.852-8.262h.005c.44-4.425-2.65-3.58-2.65-13.914",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit-top_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E64909",
    strokeWidth: 2,
    d: "m18.003 42.365-.006-13.19h.001l.007-6.823"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit-top_svg__d",
    width: 24,
    height: 24,
    x: 6,
    y: 6,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.697 7s-1.454 3.954-2.707 6.012c-1.25 2.054-3.99 4.306-3.998 7.845v.011c0-3.546-2.747-5.8-3.999-7.856C12.741 10.954 11.287 7 11.287 7h-1.77c0 10.334-3.09 9.49-2.65 13.914v-.045l.857 8.307H28.26l.852-8.262h.005c.44-4.425-2.65-3.58-2.65-13.914",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit-top_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E64909",
    strokeWidth: 2,
    d: "m24.309 24.626-.47 4.55 2.718 11.91"
  }))));
};
export default SvgPresssuitTop;